import React, { useEffect, useState } from 'react'
import PatientCalculationSection from './components/patientCalculations'
import PatientVitalSignsSection from './components/patientVitalSigns'
import { useParams } from 'react-router-dom'
import { getPatientVitalSigns } from 'services/patient'
import { IPatientVitalSignsResponse } from 'types/patient/types'

const HealthDataInitialPage: React.FC = () => {
  const { patientId } = useParams()
  const [vitalSignsState, setVitalSignsState] = useState<IStateStdTypes>('idle')
  const [patientVitalSigns, setPatientVitalSigns] =
    useState<IPatientVitalSignsResponse>()

  const fetchVitalSigns = async () => {
    const response = await getPatientVitalSigns(patientId ?? '')
    if (response.success) {
      setPatientVitalSigns(response.data)
      setVitalSignsState('success')
    } else {
      setVitalSignsState('error')
    }
  }

  useEffect(() => {
    let interval: NodeJS.Timer
    if (patientId) {
      setVitalSignsState('loading')
      fetchVitalSigns()
      interval = setInterval(() => {
        fetchVitalSigns()
      }, 60000 * 2)
    }

    return () => {
      clearInterval(interval)
    }
  }, [])

  return (
    <>
      <PatientCalculationSection
        patientId={patientId ?? ''}
        vitalSigns={patientVitalSigns}
      />
      <PatientVitalSignsSection
        patientId={patientId ?? ''}
        patientVitalSigns={patientVitalSigns}
        state={vitalSignsState}
      />
    </>
  )
}

export default HealthDataInitialPage
